import {
  FaRegEnvelope,
  FaEnvelope,
  FaGithub,
  FaPhoneAlt,
  FaLinkedinIn,
  FaTwitter,
} from 'react-icons/fa';
import { MdArrowRight } from 'react-icons/md';
import { SiFrontendmentor } from 'react-icons/si';

export const navLinks = [
  {
    id: 1,
    url: 'home',
    text: 'home',
  },
  {
    id: 2,
    url: 'projects',
    text: 'projects',
  },
  {
    id: 3,
    url: 'about',
    text: 'about',
  },
  {
    id: 4,
    url: 'contact',
    text: 'contact',
  },
];

export const projects = [
  {
    id: 1,
    subtitle: 'Ecommerce Website',
    title: 'BakedbyLey',
    description:
      'An e-commerce website for cake ordering system with a subdomain for admin\'s content management system with RESTful API using Express and MongoDB',
    technologies: ['React', 'Redux', 'Node.js', 'Express', 'MongoDB'],
    links: {
      live: 'https://bakedbyley.vercel.app/',
      github: 'https://github.com/lianpaulm/bakedbyley-capstone-project',
    },
    image: '/images/thumbnail1.png',
  },
  {
    id: 2,
    subtitle: 'Movie Web App',
    title: 'Entertainment',
    description:
      'An entertainment web app built with Next.js and Styled Components that allows users to search for movies and tv shows as well as viewing relevant information.',
    technologies: ['NextJS', 'Styled Components', 'TMDB API', 'SWR'],
    links: {
      live: 'https://lp-entertainment.vercel.app/',
      github: 'https://github.com/lianpaulm/entertainment-web-app',
    },
    image: '/images/thumbnail2.png',
  },
  {
    id: 3,
    subtitle: 'Digital Banking Landing Page',
    title: 'Easybank',
    description:
      'A beautiful responsive digital banking landing page built with React and Tailwind CSS, along with contemporary CSS techniques.',
    technologies: ['React', 'Tailwind CSS', 'Vite'],
    links: {
      live: 'https://lp-easybank-landing-page.vercel.app/',
      github: 'https://github.com/lianpaulm/easybank-landing-page',
    },
    image: '/images/thumbnail3.png',
  },
];

export const skills = {
  language: ['Javascript (ES6+)', 'HTML', 'CSS/SASS'],
  libraries: ['React', 'Redux', 'NextJS', 'Styled Components'],
  tools: ['Git & Github', 'MongoDB', 'Figma'],
  experience: ['Redux', 'Node.js', 'Express', 'MongoDB'],
  icon: <MdArrowRight />,
};

export const expertise = [
  {
    text: 'JavaScript',
    icon: (
      <img
        src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg"
        alt="javascipt-logo"
      />
    ),
  },
  // {
  //   text: 'TypeScript',
  //   icon: (
  //     <img
  //       src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg"
  //       alt="typescript-logo"
  //     />
  //   ),
  // },
  {
    text: 'ReactJS',
    icon: (
      <img
        src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg"
        alt="reactjs-logo"
      />
    ),
  },
  // {
  //   text: 'Redux',
  //   icon: (
  //     <img
  //       src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg"
  //       alt="redux-logo"
  //     />
  //   ),
  // },
  {
    text: 'Next.js',
    icon: (
      <img
        src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original-wordmark.svg"
        alt="nextjs-logo"
      />
    ),
  },
  {
    text: 'HTML5',
    icon: (
      <img
        src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg"
        alt="html5-logo"
      />
    ),
  },
  {
    text: 'CSS3',
    icon: (
      <img
        src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg"
        alt="css3-logo"
      />
    ),
  },
  {
    text: 'SASS',
    icon: (
      <img
        src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sass/sass-original.svg"
        alt="sass-logo"
      />
    ),
  },
  {
    text: 'Tailwind CSS',
    icon: (
      <img
        src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-plain.svg"
        alt="tailwindcss-logo"
      />
    ),
  },
  // {
  //   text: 'Styled Components',
  //   icon: (
  //     <img
  //       src="https://cdnjs.cloudflare.com/ajax/libs/simple-icons/2.3.0/styled-components.svg"
  //       alt="styledcomponents-logo"
  //     />
  //   ),
  // },
  {
    text: 'Git',
    icon: (
      <img
        src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg"
        alt="git-logo"
      />
    ),
  },
  {
    text: 'Figma',
    icon: (
      <img
        src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg"
        alt="figma-logo"
      />
    ),
  },
  {
    text: 'MongoDB',
    icon: (
      <img
        src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg"
        alt="mongodb-logo"
      />
    ),
  },
];

export const contactInfo = [
  {
    text: 'lianpaul.molo@gmail.com',
    icon: <FaEnvelope />,
  },
  {
    text: '0965-671-6385',
    icon: <FaPhoneAlt />,
  },
];

export const socialIcons = [
  {
    text: 'LinkedIn',
    icon: <FaLinkedinIn />,
    url: 'https://www.linkedin.com/in/lianpaulmolo/',
  },
  // {
  //   text: 'twitter',
  //   icon: <FaTwitter />,
  //   url: '/',
  // },
  {
    text: 'GitHub',
    icon: <FaGithub />,
    url: 'https://github.com/lianpaulm',
  },
  {
    text: 'Frontend Mentor',
    icon: <SiFrontendmentor />,
    url: 'https://www.frontendmentor.io/profile/lianpaulm/solutions',
  },
];
